<template>
  <div class="pb-3">
    <v-layout row class="align-center ml-2 mr-2">
      <v-flex
        xs12
        md6
        lg6
        class="d-flex d-flex-initial"
        :style="{ visibility: editMode ? 'initial' : 'hidden' }"
      >
        <v-btn color="primary" @click="addFolder('Dossier Garant')"
          ><v-icon>add</v-icon>Garant</v-btn
        >
        <v-btn color="primary" @click="addFolder('Dossier Locatif')"
          ><v-icon>add</v-icon>Locataire</v-btn
        >
      </v-flex>
      <v-flex xs12 md6 lg6 class="d-flex d-flex-initial justify-end">
        <v-btn
          color="accent"
          v-if="selectMode"
          :disabled="selectedDocs.length === 0"
          @click="mergePDFs"
        >
          <v-progress-circular
            class="mr-2"
            indeterminate
            size="18"
            v-if="mergeLoading"
          />
          <v-icon class="mr-2" v-else>save</v-icon>
          Fusionner des documents</v-btn
        >
        <v-switch
          label="Editer"
          class="mr-3"
          v-model="editModeInternal"
          v-if="editMode"
        />
        <v-switch
          label="Sélection de documents"
          class="mr-3"
          v-model="selectMode"
        />
      </v-flex>
    </v-layout>
    <v-layout
      align-center
      justify-center
      row
      fill-height
      class="ml-2 mr-2"
      v-if="editMode && (role === 'ADMIN' || role === 'SUPERADMIN')"
    >
      <v-flex
        class="d-flex d-flex-center"
        v-for="step of signatureSteps"
        v-bind:key="`generation-button-${step.value}`"
      >
        <v-btn
          v-if="
            activeSignatureSteps.indexOf(step.value) !== -1 &&
              project &&
              !signatureAlreadyExists(step.value)
          "
          color="secondary"
          class="signature-button"
          @click="createSignature(step.value)"
        >
          <div>
            Générer la signature
            <br />{{ step.text }}
          </div>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout
      align-center
      justify-center
      row
      fill-height
      class="ml-2 mr-2"
      v-if="editMode && (role === 'ADMIN' || role === 'SUPERADMIN')"
    >
      <v-flex
        class="d-flex d-flex-center"
        v-for="step of signatureSteps"
        v-bind:key="`regeneration-button-${step.value}`"
      >
        <v-btn
          v-if="
            activeSignatureSteps.indexOf(step.value) !== -1 &&
              project &&
              project.signatures.length > 0 &&
              signatureAlreadyExists(step.value)
          "
          color="secondary"
          class="signature-button"
          @click="
            sendSignatureRequest(step.value, signatureAlreadyExists(step.value))
          "
        >
          <div
            v-if="
              project &&
                project.signatures.findIndex(
                  signature =>
                    signature.step === step.value && signature.status !== 'OPEN'
                ) !== -1
            "
          >
            Regénérer la signature
            <br />{{ step.text }} <br />(<strong>déjà signée</strong>)
          </div>
          <div v-else>
            Regénérer la signature
            <br />{{ step.text }}
          </div>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout
      column
      class="ml-2 mr-2 signature-documents-row"
      v-for="signature of project.signatures"
      v-bind:key="`docs-${signature.transactionId}`"
    >
      <v-flex v-if="signature.status === 'ARCHIVED'">
        <h2>Documents de la signature {{ getStepName(signature.step) }}</h2>
        <v-layout align-center justify-center row fill-height>
          <v-flex class="d-flex d-flex-center">
            <div class="document-button-container">
              <v-btn
                color="secondary"
                class="document-button"
                @click="getProof(signature.transactionId)"
                >Obtenir la preuve</v-btn
              >
            </div>
            <div
              v-for="instance of signature.instances"
              v-bind:key="instance.id"
              class="document-button-container"
            >
              <v-btn
                color="secondary"
                class="document-button"
                @click="getFinalDoc(signature.transactionId, instance.id)"
                >Obtenir le fichier {{ instance.name }} signé</v-btn
              >
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <div v-for="f in folders" :key="f._id" class="mr-2">
      <ProjectDocumentsSection
        :folder="f"
        @add="addRequiredDoc"
        @reload="reload"
        :selectMode="selectMode"
        @toggleSelect="toggleSelect($event)"
        :withDeleteSection="editModeInternal"
        :project="project"
        :edit-mode="editMode"
      />
    </div>
    <div class="mr-2">
      <h3>Documents internes</h3>

      <v-container fluid>
        <DropZone
          :value="files"
          :edit-mode="editMode && editModeInternal"
          :type="'files'"
          :target="project._id"
          @add="fileUploaded"
          @remove="removeFile"
        />
      </v-container>
    </div>
    <v-snackbar v-model="signatureCreated" :timeout="7000"
      >Une demande de signature a été créée</v-snackbar
    >
    <v-snackbar v-model="showError" :timeout="7000"
      >Une erreur a eu lieu</v-snackbar
    >
  </div>
</template>

<script>
import { fetchHil } from "../../utils";
import ProjectDocumentsSection from "./ProjectDocumentsSection";
import { mapActions, mapState } from "vuex";
import { downloadFile } from "../../../../webapp-commons/functions";
import DropZone from "../commons/DropZone";
import { SIGNATURE_STEPS } from "../../../../webapp-commons/data";

export default {
  components: { ProjectDocumentsSection, DropZone },
  props: ["project", "editMode"],
  data() {
    return {
      showError: false,
      selectMode: false,
      selectedDocs: [],
      mergeLoading: false,
      editModeInternal: false,
      signatureSteps: SIGNATURE_STEPS,
      signatureCreated: false,
      activeSignatureSteps: []
    };
  },
  async mounted() {
    await this.reload();
    await this.refreshSignatureSteps();
  },
  computed: {
    ...mapState("projects", ["documents", "files"]),
    ...mapState("user", ["role"]),

    folders() {
      return this.documents.filter(({ type }) => type === "folder");
    }
  },
  methods: {
    ...mapActions("projects", ["fetchDocuments", "fetchFiles", "fetchProject"]),
    ...mapActions("signatureTemplates", ["fetchSignatureTemplates"]),

    async refreshSignatureSteps() {
      await this.fetchSignatureTemplates();
      this.activeSignatureSteps = this.$store.state.signatureTemplates
        ? [
            ...new Set(
              this.$store.state.signatureTemplates.signatureTemplates.items.map(
                template => (template.active ? template.step : null)
              )
            )
          ]
        : [];
      return;
    },

    signatureAlreadyExists(stepValue) {
      return (
        this.project &&
        this.project.signatures.findIndex(
          signature => signature.step === stepValue
        ) !== -1
      );
    },

    async mergePDFs() {
      if (this.mergeLoading) {
        return;
      }
      try {
        this.mergeLoading = true;
        const resp = await fetchHil(
          `/documents/for/${this.project._id}/_merge`,
          {
            method: "POST",
            body: {
              documentsId: this.selectedDocs.map(({ _id }) => _id)
            }
          }
        );
        if (!resp.ok) {
          throw new Error(resp.statusCode);
        }
        await downloadFile(resp);
      } catch (err) {
        console.error(err);
        this.showError = true;
      } finally {
        this.mergeLoading = false;
        this.$forceUpdate();
      }
    },

    async reload() {
      await Promise.all([
        this.fetchDocuments({
          id: this.project._id
        }),
        this.fetchFiles({
          id: this.project._id
        })
      ]);
    },

    async removeFile(file) {
      await fetchHil(`/cache/${file._id}`, { method: "DELETE" });
      await this.reload();
    },

    async addRequiredDoc({ value, folder }) {
      try {
        const resp = await fetchHil(`/documents/for/${this.project._id}`, {
          method: "POST",
          body: {
            name: value,
            type: "file",
            folderId: folder._id
          }
        });
        if (!resp.ok) {
          throw new Error(resp.statusCode);
        }
        await this.reload();
      } catch (err) {
        console.error(err);
        this.showError = true;
      }
      this.$forceUpdate();
    },
    toggleSelect(document) {
      if (this.selectedDocs.indexOf(document) !== -1) {
        this.selectedDocs = this.selectedDocs.filter(d => d !== document);
      } else {
        this.selectedDocs = [...this.selectedDocs, document];
      }
    },
    async addFolder(baseName) {
      let idx = 1;
      let fname = `${baseName} ${idx}`;
      console.log(`${baseName} ${idx}`, this.folders);
      while (this.folders.filter(({ title }) => title === fname).length > 0) {
        fname = `${baseName} ${++idx}`;
      }
      try {
        const resp = await fetchHil(`/documents/for/${this.project._id}`, {
          method: "POST",
          body: {
            name: fname,
            type: "folder"
          }
        });
        if (!resp.ok) {
          throw new Error(resp.statusCode);
        }
        this.docInputs = {};
        await this.reload();
      } catch (err) {
        console.error(err);
        this.showError = true;
      }
      this.$forceUpdate();
    },
    async sendSignatureRequest(step, regenerate = false) {
      if (regenerate) {
        let abortion;
        try {
          abortion = await fetchHil(`/signatures/abort/${this.project._id}`, {
            method: "PUT",
            body: {
              step
            }
          });
        } catch (e) {
          this.showError = true;
          console.log(e);
          return;
        }
        const decodedAbortion = await abortion.json();
        console.log(decodedAbortion);
      }

      let resp;
      try {
        resp = await fetchHil(`/signatures/${this.project._id}`, {
          method: "POST",
          body: {
            step
          }
        });
      } catch (e) {
        this.showError = true;
        console.log(e);
        return;
      }

      const data = await resp.json();
      console.log(data);
      if (!resp.ok) {
        this.showError = true;
      } else {
        this.signatureCreated = true;
      }
    },
    async getProof(transactionId) {
      let resp;
      try {
        resp = await fetchHil(`/signatures/proof/${transactionId}`, {
          method: "GET"
        });
      } catch (e) {
        this.showError = true;
        console.log(e);
        return;
      }

      const data = await resp.json();
      window.open(data.proof, "_blank");
    },
    async getFinalDoc(transactionId, instanceId) {
      let resp;
      try {
        resp = await fetchHil(
          `/signatures/final-doc/${this.project._id}/${transactionId}/${instanceId}`,
          {
            method: "GET"
          }
        );
      } catch (e) {
        this.showError = true;
        console.log(e);
        return;
      }

      const data = await resp.json();
      window.open(data.finalDoc);
    },
    getStepName(stepValue) {
      const step = SIGNATURE_STEPS.find(item => item.value === stepValue);
      return step.text;
    },
    async createSignature(step) {
      try {
        await this.sendSignatureRequest(step, false);
      } catch (e) {
        this.showError = true;
      }

      await this.fetchProject({
        id: this.project._id
      });
      await this.reload();
    },
    async fileUploaded() {
      await this.fetchProject({
        id: this.project._id
      });
      await this.reload();
    }
  }
};
</script>

<style>
.signature-button {
  font-size: 0.75rem;
  width: 100%;
  height: auto;
  padding: 10px;
}
.signature-documents-row {
  width: 100%;
  max-width: 100%;
}
.signature-documents-row .layout {
  width: 100%;
}
.signature-documents-row .flex {
  align-items: stretch;
  justify-content: space-between;
}
.document-button-container {
  flex-basis: 30% !important;
  flex-grow: 0 !important;
}
.document-button {
  font-size: 0.75rem;
  width: 100%;
  min-height: 36px;
  height: 100%;
  margin: 0;
}
.document-button .v-btn__content {
  width: 100%;
  height: 100%;
  padding: 10px 16px;
  white-space: normal;
}
</style>
